<template>
    <div>
        <svg :width="iconSize" :height="iconSize" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd"
                d="M6.58356 2.6848C8.52473 2.45952 10.499 2.34375 12.5 2.34375C14.501 2.34375 16.4753 2.45952 18.4164 2.6848C19.9762 2.86582 21.0938 4.20544 21.0938 5.73644V21.875C21.0938 22.1458 20.9536 22.3972 20.7232 22.5396C20.4929 22.6819 20.2053 22.6949 19.9631 22.5738L12.5 18.8422L5.03689 22.5738C4.79471 22.6949 4.5071 22.6819 4.27677 22.5396C4.04645 22.3972 3.90625 22.1458 3.90625 21.875V5.73644C3.90625 4.20544 5.02378 2.86582 6.58356 2.6848Z"
                :fill="color" 
            />
        </svg>
    </div>
</template>

<script>
export default {
    name: 'IconSvgPROLEGISMyProlegis',
    props: {
        color: {
            type: String,
            default: '#000000',
        },
        size: {
            type: Number,
            default: null
        }
    },
    computed: {
        iconSize() {
            return this.size ? `${this.size}px` : '44px'
        }
    }
};
</script>

<style scoped></style>